<template>
  <div class="turn-scale-animate" :class="{ 'open-animate': open }">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';

interface Props {
  open: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  open: false,
});
const { open } = toRefs(props);
</script>

<style lang="scss" scoped>
.turn-scale-animate {
  transform-origin: center center;
  perspective: 1000px;
  transform-style: preserve-3d;
  opacity: 1;

  &.open-animate {
    opacity: 0;
    animation: scaleUp 0.6s ease-out forwards, rotate 1.4s linear forwards;
  }
}

@keyframes scaleUp {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  20% {
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes rotate {
  0% {
    transform: rotateY(0deg) scale(0);
  }
  25% {
    transform: rotateY(360deg) scale(0.25);
  }
  50% {
    transform: rotateY(720deg) scale(0.5);
  }
  75% {
    transform: rotateY(1080deg) scale(0.75);
  }
  100% {
    transform: rotateY(1440deg) scale(1);
  }
}
</style>
